import { getProduct, getActiveProductsByVenue } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';
import {
  DraftOptionLeg,
  DraftFutureLeg,
} from '#/unified-rfqs/ui/rfq-builder/types';

export function productView(
  leg: DraftOptionLeg | DraftFutureLeg,
  isOrderbook: boolean,
) {
  const selectedProductCode = leg.productCode;
  const { venue } = getProduct(selectedProductCode);
  const isDisabled = !venueSupportsCustomStrategy(venue) || leg.isHedge;
  const products = getActiveProductsByVenue(venue, isOrderbook ? 'OB' : 'RFQ');
  const options = [
    ...products.map((p) => ({
      value: p.code,
      label: p.shortName,
    })),
  ];
  const selectedOption = options.find(
    (option) => option.value === selectedProductCode,
  );

  if (selectedOption === undefined)
    throw new TypeError(
      `Product with code '${selectedProductCode}' doesn't exist.`,
    );

  return { options, selectedOption, isValid: true as const, isDisabled };
}

export function uncategorizedProductView(
  selectedVenue: string,
  isOrderbook: boolean,
) {
  const products = getActiveProductsByVenue(
    selectedVenue,
    isOrderbook ? 'OB' : 'RFQ',
  );
  const options = [
    ...products.map((p) => ({
      value: p.code,
      label: p.shortName,
    })),
  ];
  return {
    options,
    selectedOption: null,
    isValid: false as const,
    isDisabled: false,
  };
}
